import React from "react";
import { Accordion } from "react-accessible-accordion";
import { BLOCKS } from "@contentful/rich-text-types";
import RichText from "../UI/RichText";
import { CombinatorSectionItem, Heading } from "../../ContentfulTypes";
import {
  Wrapper,
  Container,
  ExpandButtonWrapper,
  FaqButton,
  FaqDetails,
  FaqHeading,
  FaqItem,
  FaqItemTitle,
  FaqSectionTitle,
} from "./styles";

const faqBodyOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
  },
};

const faqTitleOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <FaqItemTitle>{children}</FaqItemTitle>
    ),
  },
};

const faqSectionTitleOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <FaqSectionTitle>{children}</FaqSectionTitle>
    ),
  },
};

interface Props {
  data?: Array<CombinatorSectionItem>;
  titleData?: Heading;
  isOpen?: string;
}

const ProgramFaqList = ({ data, titleData, isOpen }: Props) => (
  <Wrapper>
    <Container>
      <RichText options={faqSectionTitleOptions} document={titleData} />
      <Accordion allowMultipleExpanded allowZeroExpanded preExpanded={[`${isOpen}`]}>
        {data?.map((item) => (
          <FaqItem
            key={item?.contentful_id}
            id={item?.anchorId ?? item?.contentful_id}
            uuid={item?.anchorId ?? item?.contentful_id}
          >
            <FaqHeading>
              <FaqButton>
                <RichText
                  options={faqTitleOptions}
                  document={item.heading}
                />
                <ExpandButtonWrapper className="buttonWrapper" />
              </FaqButton>
            </FaqHeading>

            {/* Expanded content */}
            <FaqDetails>
              <RichText
                options={faqBodyOptions}
                document={item.contentBody}
              />
            </FaqDetails>
          </FaqItem>
        ))}
      </Accordion>
    </Container>
  </Wrapper>
  
);

export default ProgramFaqList;
